import { graphql } from '@api/mesa'
import { MutationRecordSurveyResponseArgs } from '@api/mesa/graphql'

export const RECORD_SURVEY_RESPONSE = graphql(`
  mutation RecordSurveyResponse(
    $surveyId: String!
    $trigger: String!
    $responseType: UserSurveyResponseType!
    $responseData: JSONObject
  ) {
    recordSurveyResponse(
      surveyId: $surveyId
      trigger: $trigger
      responseType: $responseType
      responseData: $responseData
    ) {
      items {
        id
      }
    }
  }
`)

export type SurveyResponse = MutationRecordSurveyResponseArgs
